import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';
import { IUserFile } from '@leedpulse-monorepo/interfaces';

async function getUserFiles(
  userUid: string,
  pageSize: number,
  page: number,
  auth: Authentication | null
): Promise<{
  items: IUserFile[];
  totalCount: number;
}> {
  try {
    if (!auth) throw new GetUserFilesFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const query = new URLSearchParams({ pageSize: String(pageSize), page: String(page) });

    const response = await HttpClient.get(
      `/backoffice/users/${userUid}/files?${query.toString()}`,
      auth.token
    );

    if (!response.success) throw new GetUserFilesFailure(response.message, response.code);
    return response.data;
  } catch (e) {
    if (e instanceof GetUserFilesFailure) throw e;
    throw new GetUserFilesFailure();
  }
}

export class GetUserFilesFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getUserFiles;
